import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTransactions, setFilterThunk } from 'store/transactions/transactionsActions';
import TransactionsDropzone from 'components/dropzone/TransactionsDropzone';
import { Link, Route } from 'react-router-dom';
import { TRANSACTION_LIST_CTX_TRANSACTIONS_VIEW } from 'constants/redux-store-contexts';
import { ApplicationState } from 'store/rootReducer';
import { getDefaultServiceId } from 'store/ui/service/serviceActions';
import i18n from 'i18n';
import SubTitle from 'components/dropzone/subtitle/SubTitle';
import { Button, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import PageFilter from 'components/ui/filters/PageFilter';
import MarFiles from 'views/AssetCatalog/MarFiles/MarFiles';
import {
  getAccountAiConsent,
  getUserAiConsent,
  hasUserAdminRoles,
  isBlazeVseFeatureEnabled,
  isDevTestFeatureEnabled,
  isPrivateCloud,
} from 'utils/bzmUserConfigUtil';
import { setPageFilter } from 'store/ui/pageFilters/pageFilterActions';
import DataDefinitionPanelAdapter from '../../components/tdm/DataDefinitionPanelAdapter';
import { toggleOpenDDPanel } from '../../store/ui/ddActions';
import _ from 'lodash';
import TransactionsBlazeTable from './Transactions/TransactionBlazeTable/TransactionsBlazeTable';
import Certificates from './Certificates/Certificates';
import TransactionsBulkActionsHeader from 'views/AssetCatalog/Transactions/TransactionsBulkActions/TransactionsBulkActionsHeader';
import DataDefinitionPanelContextAdapter from '../../components/tdm/DataDefinitionPanelContextAdapter';
import BzmIcon from '../../components/icons/BzmIcon';
import RestoreTransactionsModal from './Transactions/RestoreTransactions/RestoreTransactionsModal';
import { Transaction, TransactionType } from '../../types/rest/assetCatalogTypes';
import Recordings from './Recordings/Recordings';
import Blueprints from './Blueprints/Blueprints';
import BlueprintFromServiceModal from './Blueprints/BlueprintFromServiceModal';
import SandboxModal from '../../components/sandBox/SandboxModal';
import { closeSandbox } from '../../store/ui/sandboxActions';
import { createBlueprintThunk } from '../../store/blueprints/blueprintsActions';
import { Service } from '../../types/rest/assetCatalogTypes';
import { loadDevOptions } from '../../utils/localStorageUtil';

interface AssetCatalogState {
  serviceId: number;
  searchTerm: string;
  showRestoreModal: boolean;
  txType: undefined | TransactionType;
  createFromService: Service | null;
}

class AssetCatalog extends Component<AllProps, AssetCatalogState> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      serviceId: props.pageFilter.serviceId,
      searchTerm: props.pageFilter.searchTerm || '',
      showRestoreModal: false,
      txType: props.pageFilter.txType,
      createFromService: null,
    };
  }

  setFilter = (serviceId: number, searchTerm: string, type?: TransactionType) => {
    this.setState({
      serviceId,
      searchTerm,
      txType: type,
    });
  };

  //use as callback when selected a service from datapanel, then set service in local state
  setServiceId = (serviceId: number) => {
    this.setState({
      serviceId: serviceId,
      searchTerm: '',
    });
  };

  handleCreateBlueprintFromService = (service: Service) => {
    this.setState({ createFromService: service });
  };

  showRestoreModal = (keepModalOpen: boolean) => {
    this.setState({
      showRestoreModal: keepModalOpen,
    });
  };

  componentDidMount() {
    // Apply the restored filter to the transaction list on mount and fetch transactions.
    // We intentionally avoid re-dispatching setPageFilter here because the persisted page filter
    // is updated through the normal componentDidUpdate flow when the local filter state changes.
    this.props.setFilterAction(this.state.serviceId, this.state.searchTerm);
    this.props.getTransactions();
  }

  componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<any>): void {
    if (
      this.state.serviceId != null &&
      (this.state.serviceId !== prevState.serviceId ||
        this.state.searchTerm !== prevState.searchTerm ||
        this.state.txType !== prevState.txType)
    ) {
      this.props.setFilterAction(this.state.serviceId, this.state.searchTerm);
      this.props.setPageFilter({
        serviceId: this.state.serviceId,
        searchTerm: this.state.searchTerm,
        txType: this.state.txType,
      });
      this.props.getTransactions();
    }
  }

  getRestoreTxsButton = () => {
    //Don't show the button for normal users
    if (!hasUserAdminRoles(this.props.blazeUserConfig)) {
      return undefined;
    }

    return (
      <div style={{ borderRight: '1px solid #C8D1E0' }}>
        <Button
          disabled={false}
          id={'qa-dd-panel-toggle'}
          variant="secondary"
          onClick={() => this.showRestoreModal(true)}
          style={{ marginRight: '30px' }}
        >
          <div>
            <BzmIcon variant={'icon-bzm-refresh text-primary'} className={'icon-xs mr-3'} />
            <span className={'mr-2 text-primary'} style={{ verticalAlign: 'top' }}>
              {i18n.t('transactions:table.restoreTransactions')}
            </span>
          </div>
        </Button>
      </div>
    );
  };

  render() {
    const isDevTestFeatureActive =
      isDevTestFeatureEnabled(this.props.blazeUserConfig) || isBlazeVseFeatureEnabled(this.props.blazeUserConfig);
    const dropZoneSubTitle = <SubTitle />;

    return (
      <React.Fragment>
        <div className={'container-fluid'}>
          <React.Fragment>
            <div className="bg-light">
              <div className="card-deck mb-4">
                {/* Dropzone Card */}
                <div className={'card'}>
                  <div className={'card-body'}>
                    <TransactionsDropzone
                      disabled={this.props.isPrivateCloudReadOnly}
                      context={TRANSACTION_LIST_CTX_TRANSACTIONS_VIEW}
                      preselectedService={this.props.getDefaultServiceId()}
                      subtitle={dropZoneSubTitle}
                    />
                    <div className={'text-center font-size-lg'}>
                      <Link to="/how-to-import">{i18n.t('transactions:table.howToImport')}</Link>
                    </div>
                  </div>
                </div>
                {/* ./ Dropzone Card */}
              </div>
            </div>
          </React.Fragment>

          <Nav variant="tabs" defaultActiveKey="/home" className="mb-0">
            <Nav.Item id="asset-catalog-tabs-tab-transactions">
              <LinkContainer to="/asset-catalog/transactions">
                <Nav.Link href="/asset-catalog/transactions" active={false}>
                  Transactions
                </Nav.Link>
              </LinkContainer>
            </Nav.Item>
            {/* We are going to allow download of MAR files */}
            {isDevTestFeatureActive && (
              <Nav.Item id="asset-catalog-tabs-tab-marFiles">
                <LinkContainer to="/asset-catalog/mar-files">
                  <Nav.Link href="/asset-catalog/mar-files" active={false} eventKey="link-1">
                    MAR Files
                  </Nav.Link>
                </LinkContainer>
              </Nav.Item>
            )}
            <Nav.Item id="asset-catalog-tabs-tab-recordings">
              <LinkContainer to="/asset-catalog/recordings">
                <Nav.Link href="/asset-catalog/recordings" active={false}>
                  Recordings
                </Nav.Link>
              </LinkContainer>
            </Nav.Item>
            <Nav.Item id="asset-catalog-tabs-tab-certificates">
              <LinkContainer to="/asset-catalog/certificates">
                <Nav.Link href="/asset-catalog/certificates" active={false}>
                  Certificates
                </Nav.Link>
              </LinkContainer>
            </Nav.Item>
            <Nav.Item id="asset-catalog-tabs-tab-blueprints">
              <LinkContainer to="/asset-catalog/blueprints">
                <Nav.Link href="/asset-catalog/blueprints" active={false}>
                  Blueprints
                </Nav.Link>
              </LinkContainer>
            </Nav.Item>
          </Nav>

          {/* Transaction Tab Content */}
          <Route
            path="/asset-catalog/transactions"
            render={() => {
              return (
                <div className={'card'}>
                  {this.state.showRestoreModal && (
                    <RestoreTransactionsModal onHide={() => this.showRestoreModal(false)} />
                  )}
                  {this.state.createFromService && (
                    <BlueprintFromServiceModal
                      service={this.state.createFromService}
                      onSave={(draft, serviceId) => {
                        this.props.createBlueprint(draft, serviceId);
                        this.setState({ createFromService: null });
                      }}
                      onCancel={() => this.setState({ createFromService: null })}
                    />
                  )}
                  <div className={'card-body'}>
                    {this.props.sandboxOpenTransaction && (
                      <SandboxModal
                        key={this.props.sandboxOpenTransaction.id}
                        transaction={this.props.sandboxOpenTransaction}
                        onClose={this.props.closeSandbox}
                      />
                    )}
                    <DataDefinitionPanelContextAdapter
                      workspaceId={this.props.workspaceId}
                      isPanelVisible={this.props.isDDPanelOpen}
                      onClose={this.props.toggleOpenDDPanel}
                      selectedServiceId={this.props.pageFilter.serviceId}
                      services={this.props.services}
                      accountId={this.props.blazeUserConfig ? this.props.blazeUserConfig.user.activeAccountId : 0}
                      useExpressionEditor={this.props.useExpressionEditor}
                      dataModel={this.props.dataModel}
                      transactions={this.props.transactions.filteredTransactions}
                      aiConsent={getUserAiConsent()}
                      accountAiConsent={getAccountAiConsent()}
                    >
                      <PageFilter
                        setFilter={this.setFilter}
                        context={'transactions'}
                        isSearchDisabled={isPrivateCloud(this.props.blazeUserConfig)}
                        dataPanelButtonEnabled={true}
                        middleComponent={this.getRestoreTxsButton()}
                        onCreateBlueprint={loadDevOptions()?.enableBlueprintEdit ? this.handleCreateBlueprintFromService : undefined}
                      />
                      <hr />
                      <div className={'row flex-nowrap'}>
                        <div className={'col'}>
                          <TransactionsBulkActionsHeader />
                          <TransactionsBlazeTable />
                        </div>
                        {this.props.isDDPanelOpen !== undefined && this.props.isDDPanelOpen && (
                          <div className={'col-auto'}>
                            <DataDefinitionPanelAdapter
                              workspaceId={this.props.workspaceId}
                              onClose={this.props.toggleOpenDDPanel}
                              selectedServiceId={this.props.pageFilter.serviceId}
                              services={this.props.services}
                              sharedFolders={this.props.sharedFolders}
                              isPrivateDataAccount={
                                this.props.blazeUserConfig
                                  ? this.props.blazeUserConfig.user.account.features.privateData
                                  : false
                              }
                              accountId={
                                this.props.blazeUserConfig ? this.props.blazeUserConfig.user.activeAccountId : 0
                              }
                              blazeBaseUrl={this.props.blazeBaseUrl}
                              dataModel={this.props.dataModel}
                              onChangeService={(serviceId: number) => this.setServiceId(serviceId)}
                            />
                          </div>
                        )}
                      </div>
                    </DataDefinitionPanelContextAdapter>
                  </div>
                </div>
              );
            }}
          />
          {/* ./Transaction Tab Content */}

          {/* Mar Files Tab */}
          <Route path="/asset-catalog/mar-files" render={() => <MarFiles />} />
          {/* ./Mar Files Tab */}
          {/* Recordings Tab */}
          <Route path="/asset-catalog/recordings" render={() => <Recordings />} />
          {/* ./Recordings Tab */}
          {/* Certificates Tab */}
          <Route path="/asset-catalog/certificates" render={() => <Certificates />} />
          {/* ./Certificates Tab */}
          {/* Blueprints Tab */}
          <Route path="/asset-catalog/blueprints" render={() => <Blueprints />} />
          {/* ./Blueprints Tab */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  ui,
  services,
  blazeUserConfig,
  sharedFolders,
  dataModel,
  transactions,
}: ApplicationState) => {
  return {
    pageFilter: ui.pageFilter,
    isDDPanelOpen: ui.isDDPanelOpened,
    services: services.services,
    transactions,
    blazeUserConfig: blazeUserConfig.blazeUserConfig,
    isPrivateCloudReadOnly: blazeUserConfig.isPrivateCloudReadOnly,
    workspaceId: _.get(blazeUserConfig, 'blazeUserConfig.user.activeWorkspaceId', 0),
    sharedFolders,
    dataModel,
    useExpressionEditor: _.get(blazeUserConfig, 'blazeUserConfig.user.account.features.ardBeta', false),
    blazeBaseUrl: _.get(blazeUserConfig, 'blazeUserConfig.config.blazeMeterAppUrl', ''),
    sandboxOpenTransaction: ui.sandboxOpenTransaction as Transaction | null,
  };
};

const mapDispatchToProps = {
  getTransactions,
  setFilterAction: setFilterThunk,
  getDefaultServiceId,
  setPageFilter,
  toggleOpenDDPanel,
  closeSandbox,
};

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type MapDispatchToProps = typeof mapDispatchToProps;

type AllProps = MapStateToProps & MapDispatchToProps & { createBlueprint: (draft: any, serviceId: number) => void };

export default connect(mapStateToProps, (dispatch: any) => ({
  ...bindActionCreators(mapDispatchToProps, dispatch),
  createBlueprint: (draft: any, serviceId: number) => dispatch(createBlueprintThunk(draft, serviceId)),
}))(AssetCatalog as any);
